import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@nextui-org/react";
import { ZButton } from "@/shared/components/button";
import { ControlSet } from "../../requests";

type ModalType = "delete" | "markDefault";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  controlSet: ControlSet | null;
  modalType: ModalType;
  isLoading?: boolean;
}

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  controlSet, 
  modalType,
  isLoading = false 
}: ConfirmationModalProps) => {
  const getModalContent = () => {
    if (modalType === "delete") {
      return {
        title: `Are You Sure You Want to Permanently Remove ${controlSet?.controls_set_name}?`,
        description: "All existing sessions using this control set will continue to have access to these controls.",
        confirmButton: "Yes, Delete",
        confirmColor: "danger" as const,
        titleClass: "text-center leading-tight"
      };
    } else {
      return {
        title: `Mark '${controlSet?.controls_set_name}' as the Default Control Set?`,
        description: "Once marked, all new Third-Party Risk Assessments by you will use these controls by default.",
        confirmButton: "Yes, Submit",
        confirmColor: "primary" as const,
        titleClass: "text-center"
      };
    }
  };

  const content = getModalContent();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      classNames={{
        wrapper: "z-[9999]",
        backdrop: "bg-black/50"
      }}
    >
      <ModalContent className="py-4">
        <ModalHeader className="flex flex-col gap-1 px-6 pb-2 items-center">
          <h3 className={`text-lg font-semibold text-gray-900 ${content.titleClass || "text-center"}`}>
            {content.title}
          </h3>
        </ModalHeader>
        <ModalBody className="px-6 py-2 items-center">
          <p className="text-sm text-gray-600 text-center">
            {content.description}
          </p>
        </ModalBody>
        <ModalFooter className="px-6 pt-4">
          <ZButton
            variant="bordered"
            onClick={onClose}
            className="flex-1"
            isDisabled={isLoading}
          >
            Cancel
          </ZButton>
          <ZButton
            color={content.confirmColor}
            onClick={onConfirm}
            className="flex-1"
            isLoading={isLoading}
            isDisabled={isLoading}
          >
            {content.confirmButton}
          </ZButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;